import { SVGIcon } from '../Icons'
import { ISVGProps } from '../types'

const Map = (props: ISVGProps) => (
  <SVGIcon {...props}>
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1310_18232)">
        <path
          d="M17.5833 2.5L17.45 2.525L13 4.25L8 2.5L3.3 4.08333C3.125 4.14167 3 4.29167 3 4.48333V17.0833C3 17.3167 3.18333 17.5 3.41667 17.5L3.55 17.475L8 15.75L13 17.5L17.7 15.9167C17.875 15.8583 18 15.7083 18 15.5167V2.91667C18 2.68333 17.8167 2.5 17.5833 2.5ZM8.83333 4.55833L12.1667 5.725V15.4417L8.83333 14.275V4.55833ZM4.66667 5.38333L7.16667 4.54167V14.2917L4.66667 15.2583V5.38333ZM16.3333 14.6167L13.8333 15.4583V5.71667L16.3333 4.75V14.6167Z"
          fill="#555555"
        />
      </g>
      <defs>
        <clipPath id="clip0_1310_18232">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  </SVGIcon>
)

export default Map
